import {
  ArrowLeftIcon,
  ArrowRightIcon, 
  ChevronLeftIcon,
  ChevronRightIcon
} from "@chakra-ui/icons";
import {
  Select,
  Flex,
  IconButton,
  Tooltip,
  Text
} from "@chakra-ui/react";

interface PaginationProps {
  dataLegth: number;
  page: number;
  perPage: number;
  setPage: (x: number) => void;
  setPerPage: (x: number) => void;
};

const Pagination = (props: PaginationProps) => {
  const {
    dataLegth,
    page = 1,
    perPage = 10,
    setPage,
    setPerPage,
  } = props;

  return (
    <Flex justifyContent="space-between" m={4} alignItems="center">
      <Flex>
        <Tooltip label="First Page">
          <IconButton
            onClick={() => setPage(1)}
            isDisabled={page <= 1}
            icon={<ArrowLeftIcon h={3} w={3}/>}
            mr={4}
            aria-label={"First Page"}
          />
        </Tooltip>
        <Tooltip label="Previous Page">
          <IconButton
            onClick={() => {
              if (page > 1) setPage(page - 1);
            }}
            isDisabled={page == 1}
            icon={<ChevronLeftIcon h={6} w={6}/>}
            aria-label={"Previous Page"}
          />
        </Tooltip>
      </Flex>

      <Flex alignItems="center">
        <Text flexShrink="0" mx={8}>
          Page{" "}
          <Text fontWeight="bold" as="span">
            {page}{" "}
          </Text>
          of{" "}
          <Text fontWeight="bold" as="span">
            {Math.ceil(dataLegth/perPage)}
          </Text>
        </Text>
        <div
          className={"max-[600px]:hidden"}
        >
          <Select
            mr={8}
            value={perPage}
            onChange={(e) => {
              const newNumber = Number(e.target.value);
              setPerPage(newNumber);
              setPage(1);
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </Select>
        </div>
      </Flex>

      <Flex>
        <Tooltip label="Next Page">
          <IconButton
            onClick={() => setPage(page + 1)}
            isDisabled={page >= (dataLegth/perPage)}
            icon={<ChevronRightIcon h={6} w={6}/>}
            aria-label={"Next Page"}
          />
        </Tooltip>
        <Tooltip label="Last Page">
          <IconButton
            onClick={() => setPage(Math.ceil(dataLegth/perPage))}
            isDisabled={page >= Math.ceil(dataLegth/perPage)}
            icon={<ArrowRightIcon h={3} w={3}/>}
            ml={4}
            aria-label={"Last Page"}
          />
        </Tooltip>
      </Flex>
    </Flex>
  )
};


export default Pagination;